'use client';

import clsx from 'clsx';
import Image from 'next/image';

import buildSystemOfChoice from './BuildScan_BuildSystemOfChoice@3x.png';
import dependencies from './BuildScan_Dependencies@3x.png';
import compare from './BuildScan_CompareScans@3x.png';
import collaboration from './BuildScan_Collaborate@3x.png';

const benefitsData = [
  {
    id: 1,
    title: 'Use your build system of choice',
    body: 'Develocity Build Scan supports Gradle, Maven, Bazel, and sbt build systems.',
    content: (
      <div className="relative aspect-[1.4/1] h-auto w-full lg:aspect-[1.2/1]">
        <Image
          src={buildSystemOfChoice}
          alt="Illustration of supported build systems"
          fill
          className="rounded-2xl object-cover"
        />
      </div>
    ),
    gridClass: '',
  },
  {
    id: 2,
    title: 'Compare scans to pinpoint failure root cause',
    body: 'Build Scan Comparison shows differences in the task inputs and dependency trees between builds, so you can identify the cause of a cache miss or debug a bad input.',
    content: (
      <div className="relative aspect-[1.4/1] h-auto w-full self-end lg:aspect-[1.2/1]">
        <Image src={compare} alt="Illustration of build scan comparison" fill className="rounded-2xl object-contain" />
      </div>
    ),
    gridClass: '',
  },
  {
    id: 3,
    title: 'Easily collaborate and search',
    body: 'Collaborate seamlessly with colleagues by sharing any detail of a Build Scan using a deep link to a specific data point.',
    content: (
      <div className="relative aspect-[1.4/1] h-auto w-full lg:aspect-[1.2/1]">
        <Image
          src={collaboration}
          alt="Illustration of collaboration features"
          fill
          className="rounded-2xl object-cover"
        />
      </div>
    ),
    gridClass: '',
  },
  {
    id: 4,
    title: 'Discover dependency-related failures',
    body: 'Use the dependency view to understand where a dependency originated and resolve dependency conflicts.',
    content: (
      <div className="relative aspect-[1.4/1] h-auto w-full lg:aspect-[1.2/1]">
        <Image src={dependencies} alt="Illustration of dependency view" fill className="rounded-2xl object-cover" />
      </div>
    ),
    gridClass: '',
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      className="min-h-screen-with-nav py-section text-body grid bg-gray-1 px-4 text-center text-white md:px-10"
    >
      <div className="max-w-section grid h-full grid-rows-1 gap-6 lg:grid-cols-2">
        {benefitsData.map(item => (
          <div
            key={item.id.toString()}
            className={clsx(
              'flex flex-col justify-between rounded-3xl border border-dark-background bg-[#13171B] p-8 text-left md:p-10',
              item.gridClass,
            )}
          >
            <div className="mb-8 flex flex-col gap-4">
              <h4 className="text-h6">{item.title}</h4>
              <p className="text-body max-w-3xl text-gray-4">{item.body}</p>
            </div>
            {item.content}
          </div>
        ))}
      </div>
    </section>
  );
}
